<template>
    <div class="login-form">
        <div class="login-form__title">
            {{ title }}
        </div>
        <form v-if="mode === 'login'" class="form" @submit.prevent="login">
            <div class="login-form__row">
                <FormInput
                    :key="'login'"
                    v-model="user.username"
                    :error="error && error['non_field_errors']"
                    :placeholder="$t('login.email')"
                    type="text"
                    required
                    @focus="error = null"
                >
                    <template #prepend>
                        <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.5 8.31412C10.3901 8.31412 11.9225 6.45296 11.9225 4.15708C11.9225 1.86116 11.4194 0 8.5 0C5.58062 0 5.07742 1.86116 5.07742 4.15708C5.07742 6.45296 6.6098 8.31412 8.5 8.31412Z"
                                fill="#D8D8E1"
                            />
                            <path
                                d="M2.03559 14.6614C2.035 14.5214 2.03442 14.622 2.03559 14.6614V14.6614Z"
                                fill="#D8D8E1"
                            />
                            <path
                                d="M14.9641 14.7708C14.966 14.7324 14.9648 14.5049 14.9641 14.7708V14.7708Z"
                                fill="#D8D8E1"
                            />
                            <path
                                d="M14.9569 14.4936C14.8935 10.4941 14.3711 9.35448 10.374 8.6331C10.374 8.6331 9.81139 9.35006 8.49996 9.35006C7.18853 9.35006 6.62578 8.6331 6.62578 8.6331C2.67231 9.34661 2.11821 10.4693 2.04535 14.3637C2.03937 14.6817 2.03661 14.6984 2.03554 14.6615C2.03578 14.7306 2.03607 14.8586 2.03607 15.0816C2.03607 15.0816 2.98768 17 8.49996 17C14.0121 17 14.9639 15.0816 14.9639 15.0816C14.9639 14.9383 14.964 14.8386 14.9641 14.7708C14.963 14.7937 14.9609 14.7494 14.9569 14.4936Z"
                                fill="#D8D8E1"
                            />
                        </svg>
                    </template>
                </FormInput>
            </div>
            <div class="login-form__row">
                <PasswordFormInput
                    v-model="user.password"
                    :error="error && error['non_field_errors']"
                    :placeholder="$t('login.password')"
                    required
                    @focus="error = null"
                />
            </div>
            <div class="form__row">
                <button :disabled="loading" class="button button--big login-form__button">
                    {{ $t('login.signIn') }}
                </button>
            </div>
        </form>

        <form v-if="mode === 'join'" class="form" @submit.prevent="join">
            <div class="login-form__row">
                <FormInput
                    ref="email"
                    v-model="user.email"
                    :error="error && error['email']"
                    :placeholder="$t('login.email')"
                    type="email"
                    required
                    @focus="error = null"
                >
                    <template #prepend>
                        <svg
                            tabindex="-1"
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0)">
                                <path
                                    d="M2.11157 7.68537C2.38986 7.88175 3.22875 8.46501 4.62828 9.43483C6.02785 10.4047 7.10001 11.1514 7.84482 11.6751C7.92665 11.7325 8.1005 11.8573 8.36645 12.0496C8.63245 12.2421 8.85347 12.3976 9.02934 12.5163C9.20534 12.6349 9.41811 12.7679 9.66785 12.9152C9.91751 13.0623 10.1529 13.173 10.3738 13.2463C10.5949 13.3202 10.7994 13.3567 10.9877 13.3567H11H11.0124C11.2006 13.3567 11.4053 13.3201 11.6263 13.2463C11.8472 13.173 12.0827 13.0622 12.3322 12.9152C12.5818 12.7677 12.7945 12.6348 12.9705 12.5163C13.1465 12.3976 13.3674 12.2421 13.6335 12.0496C13.8994 11.8571 14.0734 11.7325 14.1553 11.6751C14.9081 11.1514 16.8235 9.82136 19.9007 7.68511C20.4982 7.26788 20.9973 6.76444 21.3983 6.17512C21.7996 5.58606 22 4.9681 22 4.3216C22 3.78134 21.8055 3.31888 21.4167 2.93424C21.0279 2.54952 20.5675 2.35726 20.0357 2.35726H1.9642C1.33404 2.35726 0.849081 2.57003 0.509423 2.99556C0.169808 3.42117 0 3.95317 0 4.59151C0 5.10712 0.225149 5.66587 0.675231 6.2674C1.12527 6.86897 1.60421 7.34167 2.11157 7.68537Z"
                                    fill="#D8D8E1"
                                />
                                <path
                                    d="M20.7722 8.99885C18.0879 10.8157 16.0497 12.2276 14.6585 13.2344C14.192 13.578 13.8136 13.8463 13.5229 14.0385C13.2323 14.2308 12.8458 14.4272 12.3628 14.6277C11.88 14.8284 11.43 14.9284 11.0125 14.9284H11H10.9877C10.5703 14.9284 10.1201 14.8284 9.63727 14.6277C9.15447 14.4272 8.76768 14.2308 8.47713 14.0385C8.18666 13.8463 7.80809 13.578 7.34163 13.2344C6.23665 12.4242 4.20283 11.0122 1.24008 8.99885C0.773443 8.68805 0.360126 8.33179 0 7.93082V17.6783C0 18.2188 0.192254 18.681 0.576976 19.0657C0.961612 19.4505 1.42412 19.6429 1.96433 19.6429H20.0358C20.5759 19.6429 21.0384 19.4505 21.423 19.0657C21.8079 18.6809 22 18.2189 22 17.6783V7.93082C21.648 8.32349 21.2389 8.67975 20.7722 8.99885Z"
                                    fill="#D8D8E1"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="22" height="22" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </template>
                </FormInput>
            </div>
            <div class="login-form__row">
                <PasswordFormInput
                    v-model="user.password"
                    :error="error && error['password1']"
                    :placeholder="$t('login.password')"
                    required
                    @focus="error = null"
                />
            </div>
            <div class="login-form__row">
                <PasswordFormInput
                    v-model="user.password2"
                    :error="error && error['non_field_errors']"
                    :placeholder="$t('login.password')"
                    required
                    @focus="error = null"
                />
            </div>
            <div class="form__row">
                <button :disabled="loading" class="button button--big login-form__button">
                    {{ $t('login.signUp') }}
                </button>
            </div>
        </form>

        <form v-if="mode === 'reset'" class="form" @submit.prevent="requestResetPassword">
            <div v-if="passwordResetSuccess" style="margin-bottom: 15px">
                {{ $t('login.reset.linkSent', { email: user.email }) }}
            </div>
            <div v-if="!passwordResetSuccess" class="login-form__row">
                <FormInput
                    :key="'login'"
                    v-model="user.email"
                    :error="error && error['non_field_errors']"
                    :placeholder="$t('login.email')"
                    type="text"
                    required
                    @focus="error = null"
                >
                    <template #prepend>
                        <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.5 8.31412C10.3901 8.31412 11.9225 6.45296 11.9225 4.15708C11.9225 1.86116 11.4194 0 8.5 0C5.58062 0 5.07742 1.86116 5.07742 4.15708C5.07742 6.45296 6.6098 8.31412 8.5 8.31412Z"
                                fill="#D8D8E1"
                            />
                            <path
                                d="M2.03559 14.6614C2.035 14.5214 2.03442 14.622 2.03559 14.6614V14.6614Z"
                                fill="#D8D8E1"
                            />
                            <path
                                d="M14.9641 14.7708C14.966 14.7324 14.9648 14.5049 14.9641 14.7708V14.7708Z"
                                fill="#D8D8E1"
                            />
                            <path
                                d="M14.9569 14.4936C14.8935 10.4941 14.3711 9.35448 10.374 8.6331C10.374 8.6331 9.81139 9.35006 8.49996 9.35006C7.18853 9.35006 6.62578 8.6331 6.62578 8.6331C2.67231 9.34661 2.11821 10.4693 2.04535 14.3637C2.03937 14.6817 2.03661 14.6984 2.03554 14.6615C2.03578 14.7306 2.03607 14.8586 2.03607 15.0816C2.03607 15.0816 2.98768 17 8.49996 17C14.0121 17 14.9639 15.0816 14.9639 15.0816C14.9639 14.9383 14.964 14.8386 14.9641 14.7708C14.963 14.7937 14.9609 14.7494 14.9569 14.4936Z"
                                fill="#D8D8E1"
                            />
                        </svg>
                    </template>
                </FormInput>
            </div>
            <div v-if="!passwordResetSuccess" class="form__row">
                <button :disabled="loading" class="button button--big login-form__button">
                    {{ $t('login.reset.request') }}
                </button>
            </div>
        </form>

        <button v-if="mode === 'join'" class="link login-form__switcher" @click="setMode('login')">
            {{ $t('login.haveAnAccount') }}
        </button>

        <template v-if="mode === 'login'">
            <!-- <button class="link login-form__switcher" @click="setMode('join')">
                {{ $t('login.signUp') }}
            </button> -->
            <button class="link login-form__switcher" @click="setMode('reset')">
                {{ $t('login.reset.trigger') }}
            </button>
        </template>

        <button v-if="mode === 'reset'" class="link login-form__switcher" @click="setMode('login')">
            {{ $t('misc.back') }}
        </button>

        <p v-if="mode === 'join'" class="login-form__policy">
            {{ $t('login.agreement') }}
            <router-link class="link" to="/docs/agreement">
                {{ $t('login.terms') }}
            </router-link>
        </p>
    </div>
</template>

<script>
import { FormInput, PasswordFormInput } from '@speechki-frontend/shared/ui/forms';

import { fetchHelpText, requestResetPassword } from '../../api';

import { mapActions } from 'vuex';

export default {
    name: 'LoginForm',
    components: {
        FormInput,
        PasswordFormInput,
    },
    data() {
        return {
            mode: 'login',
            user: {
                username: '',
                password: '',
                email: '',
                password2: '',
                referalId: '',
            },
            error: null,
            loading: false,
            helpTextArray: null,
            passwordResetSuccess: false,
        };
    },
    computed: {
        title() {
            return {
                login: this.$t('login.signIn'),
                join: this.$t('login.signUp'),
                reset: this.$t('login.reset.title'),
            }[this.mode];
        },
        helpText() {
            if (!this.helpTextArray || !this.helpTextArray.detail) return '';
            return this.helpTextArray.detail.join('<br>');
        },
    },
    watch: {
        mode() {
            this.error = null;
            this.passwordResetSuccess = false;
        },
    },
    created() {
        if (this.$route.query.mode) {
            this.mode = this.$route.query.mode;
        }
        fetchHelpText().then((res) => (this.helpTextArray = res));
    },
    mounted() {
        if (this.$route.query.useremail) {
            this.user.email = this.$route.query.useremail;
            this.$nextTick(() => {
                this.$refs.email.focus();
            });
        }

        if (this.$route.query.referal_id) {
            this.user.referalId = this.$route.query.referal_id;
        }
    },
    methods: {
        ...mapActions(['signIn', 'signUp']),
        toggleMode() {
            this.mode === 'join' ? (this.mode = 'login') : (this.mode = 'join');
        },
        setMode(mode) {
            this.mode = mode;
        },
        async login() {
            this.error = null;
            this.loading = true;
            const { username, password } = this.user;
            try {
                await this.signIn({ username, password });
                this.loading = false;

                const lastRoute = localStorage.getItem('lastroute');
                if (lastRoute) {
                    this.$router.push(lastRoute);
                } else {
                    this.$router.push({ name: 'home' });
                }
            } catch (error) {
                this.loading = false;
                this.error = error;
            }
        },
        async join() {
            this.error = null;
            this.loading = true;
            const { password, email, password2, referalId } = this.user;

            let username = email;
            let password1 = password;

            try {
                await this.$store.dispatch('join', {
                    username,
                    password1,
                    email,
                    password2,
                    referalId,
                });

                await this.$store.dispatch('signIn', { username, password });

                this.loading = false;

                this.$router.push({ name: 'home' });
            } catch (error) {
                this.error = error;
                this.loading = false;
            }
        },
        async requestResetPassword() {
            this.error = null;
            this.loading = true;

            const { email } = this.user;

            try {
                await requestResetPassword(email);
                this.passwordResetSuccess = true;
            } catch (e) {
                this.error = e;
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" src="./LoginForm.scss"></style>
